var swiper = new Swiper(".collection-slider", {
    pagination: {
    el: '.swiper-paginations',
    clickable: true,
  },
   navigation: {
        nextEl: '.swiper-button-nexts',
        prevEl: '.swiper-button-prevs',
      },
  breakpoints: {
    1200: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1.30,
      spaceBetween: 10,
    },
  }
});